import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useForm, useFieldArray } from "react-hook-form";
import { Form, Col, Button, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { formInputFields, validationSchema } from "./FormHelper";
import {
  updateDataOnRequest,
  getDataOnRequest,
} from "../../../redux/actions/CommonActions";
import LoadFormFields from "../../Layout/LoadFormFields";
import IndividualRiskContainer from "../../../containers/IndividualRiskContainer";
const IndividualRisk = (props) => {
  const [riskMaster, setRiskMaster] = useState([]);
  const { loader, userDetails, individual, riskProfile, careplan } = props;
  const dispatch = useDispatch();
  const [individuals, setFormdata] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    removeValue,
    control,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onBlur",
    reValidateMode: "onBlur",
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "individualRisk",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (formInputFields(individual).length > 0)
      formInputFields().map((field) => {
        if (individual[field.name])
          setValue(field.name, individual[field.name]);
      });
    let riskMaster = [{ name: "Select Risk Profile", id: "" }];
    if (riskProfile) {
      riskProfile.map((risk) => {
        riskMaster.push({ name: risk.clt_risk_title, id: risk.clt_risk_id });
      });
      setRiskMaster(riskMaster);
    }
    if (individual.length <= 0) {
      let defaultFormData = [
        {
          users_access_token: userDetails && userDetails.users_access_token,
          clt_risk_profile_id: "",
          clt_risk_profile_careplan_id: careplan && careplan.clt_care_id,
          clt_risk_profile_master_id: "",
          clt_risk_profile_high: "",
          clt_risk_profile_medium: "",
          clt_risk_profile_low: "",
        },
      ];
      setValue("individualRisk", defaultFormData);
      setFormdata(defaultFormData);
    } else {
      setValue("individualRisk", individual);
      setFormdata(individual);
    }
  }, [individual, riskProfile, careplan]);

  const onSubmit = (data) => {
    let formData = data["individualRisk"];
    formData[0]["users_access_token"] = userDetails.users_access_token;
    dispatch(
      updateDataOnRequest(
        JSON.stringify(formData, null, 2),
        "SaveIndividualRiskProfile",
        "",
        getDataOnRequest(
          userDetails.users_access_token,
          "GetIndividualRisk",
          "SET_INDIVIDUAL_RISK"
        )
      )
    );
  };

  const onChangeInputvalue = (e, key) => {
    const { name, value } = e.target;
    individuals[key][name] = value;
    setFormdata(individuals);
  };

  const addMore = () => {
    let loadMoredata = [
      ...individuals,
      {
        users_access_token: userDetails.users_access_token,
        clt_risk_profile_id: "",
        clt_risk_profile_careplan_id: careplan && careplan.clt_care_id,
        clt_risk_profile_master_id: "",
        clt_risk_profile_high: "",
        clt_risk_profile_medium: "",
        clt_risk_profile_low: "",
      },
    ];
    setFormdata(loadMoredata);
    append({
      users_access_token: userDetails.users_access_token,
      clt_risk_profile_id: "",
      clt_risk_profile_careplan_id: careplan && careplan.clt_care_id,
      clt_risk_profile_master_id: "",
      clt_risk_profile_high: "",
      clt_risk_profile_medium: "",
      clt_risk_profile_low: "",
    });
  };

  const handleRemoveClick = (index) => {
    const list = [...individuals];
    list.splice(index, 1);
    setFormdata(list);
    remove(index);
  };
  return (
    <React.Fragment>
      <div className="job-bx submit-resume">
        <div className="job-bx-title clearfix">
          <h5 className="font-weight-700 pull-left text-uppercase">
            Individual Risk Profile
          </h5>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {individuals.map((individualData, i) => (
            <React.Fragment key={i}>
              {individuals.length !== 1 && (
                <>
                  <h6>Risk - {i + 1}</h6>
                  <Link to="#" onClick={(e) => handleRemoveClick(i)}>
                    <i className="pull-right fa fa-trash red-icon"></i>
                  </Link>
                  <hr />
                </>
              )}
              <LoadFormFields
                key={i}
                register={register}
                control={control}
                errors={errors.individualRisk && errors.individualRisk[i]}
                formInputFields={formInputFields(riskMaster, i)}
                onChangeInputvalue={(e) => onChangeInputvalue(e)}
                reset={reset}
                addMoreButton={true}
                arrayForm={true}
                addMore={addMore}
                data={individualData}
                loadExternalButtons={true}
              />

              {individuals.length === 1 && <hr />}
            </React.Fragment>
          ))}
          <Form.Group as={Col} md="12" sm="12">
            <Button
              disabled={loader ? "disabled" : ""}
              className="site-button m-b30 float-right"
              type="submit"
            >
              {loader && (
                <Spinner
                  as="span"
                  variant="light"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  animation="border"
                />
              )}
              {!loader && "Save"}
            </Button>
            <Button
              className="m-r5 site-button yellow m-b30 float-right"
              onClick={addMore}
              type="button"
            >
              Add More
            </Button>
            <Button
              disabled={loader ? "disabled" : ""}
              className="m-b30 m-r5 site-button orange float-right"
              onClick={() => reset()}
            >
              {loader && (
                <Spinner
                  as="span"
                  variant="light"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  animation="border"
                />
              )}
              {!loader && "Reset"}
            </Button>
          </Form.Group>
        </form>
        <br />
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    errors: state.error.error,
    loader: state.loader.loader,
    userDetails: state.auth.authUserData,
    individual: state.individual.individual,
    careplan: state.careplan.careplan,
    riskProfile: state.individual.riskProfile,
  };
};
export default connect(mapStateToProps)(
  IndividualRiskContainer(IndividualRisk)
);
